// The order of groups and fields inside groups is IMPORTANT. It will do the sorting of columns following the sequence from here.
// However, on UI they will be sorted alphabetically
export const fixturesExportFields = [
  {
    titleIntlKey: "fixtures.columns.competition.title",
    fields: ["competitionId", "competitionExternalId", "competitionName"],
  },
  {
    titleIntlKey: "fixtures.columns.season.title",
    fields: ["seasonId", "seasonExternalId", "seasonName"],
  },
  {
    titleIntlKey: "fixtures.columns.fixture.title",
    fields: [
      "fixtureId",
      "forceFixtureId",
      "externalId",
      "fixtureType",
      "status",
      "roundNumber",
      "fixtureNumber",
      "startTimeLocal",
      "startTimeUtc",
      "discipline",
      "attendance",
      "nameLocal",
      "nameLatin",
      "internationalReference",
      "duration",
      "durationFull",
    ],
  },
  {
    titleIntlKey: "fixtures.columns.venue.title",
    fields: ["venueId", "venueExternalId", "venueName"],
  },
  {
    titleIntlKey: "fixtures.columns.fixtureProfile.title",
    fields: ["fixtureProfileId", "fixtureProfileExternalId", "fixtureProfileName"],
  },
  {
    titleIntlKey: "fixtures.columns.home.title",
    fields: [
      "homeIds",
      "homeExternalIds",
      "homeNames",
      "homeScores",
      "homeSecondaryScores",
      "homeResultStatuses",
      "homeDraws",
      "homeResultPlaces",
      "homeResultSecondaryScorePlaces",
    ],
  },
  {
    titleIntlKey: "fixtures.columns.away.title",
    fields: [
      "awayIds",
      "awayExternalIds",
      "awayNames",
      "awayScores",
      "awaySecondaryScores",
      "awayResultStatuses",
      "awayDraws",
      "awayResultPlaces",
      "awayResultSecondaryScorePlaces",
    ],
  },
  {
    titleIntlKey: "fixtures.columns.stage.title",
    fields: ["stageCode", "stageExternalId", "stageName"],
  },
  {
    titleIntlKey: "fixtures.columns.pool.title",
    fields: ["poolCode", "poolExternalId", "poolName"],
  },
  {
    titleIntlKey: "fixtures.columns.series.title",
    fields: ["seriesCode", "seriesExternalId", "seriesName"],
  },
];

export const defaultFixturesExportFieldNames = [
  "competitionName",
  "seasonName",
  "fixtureId",
  "fixtureType",
  "status",
  "startTimeLocal",
  "fixtureNumber",
  "venueName",
  "homeNames",
  "homeScores",
  "homeSecondaryScores",
  "homeResultStatuses",
  "awayNames",
  "awayScores",
  "awaySecondaryScores",
  "awayResultStatuses",
  "roundNumber",
  "stageName",
  "poolName",
  "seriesName",
];
